var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocationJobInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.8185L4.25736 11.5759C1.91421 9.23272 1.91421 5.43376 4.25736 3.09061C6.60051 0.747465 10.3995 0.747465 12.7427 3.09061C15.0858 5.43376 15.0858 9.23272 12.7427 11.5759L8.5 15.8185ZM11.7998 10.6331C13.6223 8.81065 13.6223 5.85587 11.7998 4.03342C9.9774 2.21097 7.02261 2.21097 5.20017 4.03342C3.37772 5.85587 3.37772 8.81065 5.20017 10.6331L8.5 13.9329L11.7998 10.6331ZM8.5 8.66659C7.7636 8.66659 7.16667 8.06965 7.16667 7.33325C7.16667 6.59687 7.7636 5.99992 8.5 5.99992C9.2364 5.99992 9.83333 6.59687 9.83333 7.33325C9.83333 8.06965 9.2364 8.66659 8.5 8.66659Z",
    fill: "#A3A3A3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationJobInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location_job_info.0aa054f5.svg";
export { ForwardRef as ReactComponent };